import { AddOnTextInput, Card, ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { AdditionalStopsFormData, FormRegister, FormErrors } from "../types";

interface AdditionalUnscheduledStopsCardProps {
  register: FormRegister<AdditionalStopsFormData>;
  errors: FormErrors<AdditionalStopsFormData>;
  unscheduledStops?: number;
  unscheduledStopsFee?: number;
  isLoadingFees: boolean;
}

export const AdditionalUnscheduledStopsCard = ({
  register,
  errors,
  unscheduledStops,
  unscheduledStopsFee,
  isLoadingFees,
}: AdditionalUnscheduledStopsCardProps) => {
  return (
    <Card as="fieldset">
      <Typography variant="title">Additional Unscheduled Stops</Typography>

      <div className="flex mb-1 mt-3 gap-2.5">
        <div className="flex-1 flex-col gap-1">
          <Typography variant="action" className=" text-neutral-dark-gray">
            Additional Stop
          </Typography>
          <TextInput
            placeholder="1"
            type="number"
            className="flex-1"
            {...register("additionalUnscheduledStops", { valueAsNumber: true })}
          />
        </div>
        <div className="flex-1 flex-col gap-1">
          <Typography variant="action" className="text-neutral-dark-gray">
            Fee
          </Typography>
          <AddOnTextInput
            value={unscheduledStops ? unscheduledStopsFee : ""}
            startAddOn="AUD $"
            placeholder="10.00"
            tabIndex={-1}
            className="flex-1"
            readOnly
            disabled={isLoadingFees}
          />
        </div>
        <ErrorMessage errors={errors} name="additionalUnscheduledStops" />
      </div>
    </Card>
  );
};
